<script lang="ts">
	import type { FAQEntry as FAQEntryType } from './types.ts';
	import FAQEntry from '$lib/components/seo/FAQEntry.svelte';
	import * as m from '$paraglide/messages.js';

	interface Props {
		data: FAQEntryType[];
	}

	const { data }: Props = $props();
	let expandedQuestionIndex: number | null = $state(null);

	function handleExpand(expand: boolean, index: number) {
		expand ? (expandedQuestionIndex = index) : (expandedQuestionIndex = null);
	}
</script>

<section itemscope itemtype="https://schema.org/FAQPage" class="px-8">
	<div class="text-center text-coloredneutral text-bold py-4">{m.footer__faq_title()}</div>
	<div class="px-8 pt-4 pb-2 rd-2 bg-neutral-weakest">
		<!-- eslint-disable-next-line svelte/require-each-key -->
		{#each data as { question, answerHtml }, index}
			<FAQEntry
				{question}
				{answerHtml}
				noBottomBorder={index === data.length - 1}
				onExpand={e => handleExpand(e, index)}
				isExpanded={expandedQuestionIndex === index}
			/>
		{/each}
	</div>
</section>
